import { render, staticRenderFns } from "./CPDbadge.vue?vue&type=template&id=3afa8ea6&"
import script from "./CPDbadge.vue?vue&type=script&lang=js&"
export * from "./CPDbadge.vue?vue&type=script&lang=js&"
import style0 from "./CPDbadge.vue?vue&type=style&index=0&id=3afa8ea6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports